$(function () {

  $('a[data-change-model-url]').each(function () {
    // Получаем текущее значение атрибута
    const url = $(this).data('change-model-url');
    const origin = window.location.origin;
    console.log(origin, 'origin')
    if (origin !== 'http://localhost' && origin !== 'https://changanauto.ru' && origin !== 'https://changanauto.4px.site') {
      return;
    }
    if (url === 'uni-t') {
      $(this)
        .attr('href', 'https://uni-motors.ru/model/uni-t') // ставим новый href
        .attr('target', '_blank');                  // открывать в новой вкладке
    }
    if (url === 'uni-v') {
      $(this)
        .attr('href', 'https://uni-motors.ru/model/uni-v') // ставим новый href
        .attr('target', '_blank');                  // открывать в новой вкладке
    }
    if (url === 'uni-k') {
      $(this)
        .attr('href', 'https://uni-motors.ru/model/uni-k') // ставим новый href
        .attr('target', '_blank');                  // открывать в новой вкладке
    }
    if (url === 'uni-k_idd') {
      $(this)
        .attr('href', 'https://uni-motors.ru/model/uni-k-idd') // ставим новый href
        .attr('target', '_blank');                  // открывать в новой вкладке
    }
  });

});
